export default __webpack_public_path__ + "static/media/3.6a04ea11.jpg";